var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from '../Box';
import { applyVariations, getPaletteColor, deprecatedColorValue } from '../utils';
var boxBorder = function (_a) {
    var borderWidth = _a.borderWidth, borderColor = _a.borderColor, props = __rest(_a, ["borderWidth", "borderColor"]);
    return ({
        border: borderWidth === 0 ? '0' : "".concat(borderWidth, "px solid ").concat(getPaletteColor(borderColor, 'base')(props)),
    });
};
var propTypes = {
    borderColor: deprecatedColorValue(),
    color: deprecatedColorValue(),
    borderWidth: PropTypes.oneOf([0, 1, 2]),
};
var Card = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), applyVariations('Card'), boxBorder);
Card.propTypes = propTypes;
Card.defaultProps = {
    borderColor: 'border',
    borderRadius: 'xsm',
    borderWidth: 1,
};
Card.displayName = 'Card';
export default Card;
var templateObject_1;
//# sourceMappingURL=Card.js.map